import moment from "moment";
import React, { useEffect, useState, useRef, useCallback } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "react-quill/dist/quill.snow.css";
import { Remove, RemoveCircle } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "react-bootstrap/Button";
import { Table } from "react-bootstrap";
import button from "bootstrap/js/src/button";
import { showMessage } from "../../Utils/comman"; // import styles for the editor

function LogisticLoadingForm(props) {
  const [action, setAction] = useState("add");
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    orderId: "",
    llDate: new Date(),
    dcNo: "",
    startTime: "",
    endTime: "",
    vehicleNo: "",
    transporterName: "",
    partyName: "",
    lrNo: "",
    soNo: "",
  });
  const [shipments, setShipments] = useState([
    {
      shipmentId: "",
      shipmentName: "",
      address: "",
      addressType: "",
      shipmentMethod: "",
      godownId: "",
      godownName: "",
      items: [
        {
          id: 0,
          productId: 0,
          productName: "",
          mainProductId: "",
          batchNo: "",
          mfg: "",
          noBags: "",
          qty: 0,
          remarks: "",
          location: "",
        },
      ],
      products: [
        {
          productId: 0,
          productName: "",
          mainProductId: "",
          qty: 0,
        },
      ],
    },
  ]);
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const [piData, setPiData] = useState([]);
  const [orderId, setOrderId] = useState(0);
  const [officeLocation, setOfficeLocation] = useState([]);
  const [removedItemIds, setRemovedItemIds] = useState([]);

  useEffect(() => {
    setOrderId(
      props?.rowData?.orderdata && props?.rowData?.orderdata.id
        ? props?.rowData?.orderdata.id
        : props?.rowData?.id
    );
    // getPiData();
  }, []);

  useEffect(() => {
    if (orderId > 0) {
      getLocationList();
      getLoadingData();
    }
  }, [orderId]);

  const getLoadingData = () => {
    utils
      .callAPI("get", `/sales/getlogisticDataList?id=${orderId}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const piData = res?.pi_response;
          const shipments = [];

          if (res.logisticdata) {
            setAction("edit");
            const logisticData = res?.logisticdata;
            // console.log(logisticData)
            res?.shipment &&
              res?.shipment.map((shipmentData, index) => {
                const shipmentItems = [];
                const products = [];
                // console.log(logisticData.filter(l => l.shipment_id === shipmentData.id))
                shipmentData.items.map((item) => {
                  products.push({
                    productId: item.id,
                    mainProductId: item.item_name,
                    // productId: item.product_id,
                    productName: item.product_name,
                    qty: item.item_qty,
                  });
                });
                // shipmentData.items.map(item => {
                logisticData
                  .filter((l) => l.shipment_id === shipmentData.id)
                  .map((item) => {
                    console.log("before map items", item);
                    // console.log(parseInt(item.product_id), shipmentData.items);
                    const product = shipmentData.items.find(
                      (p) => parseInt(p.item_name) === parseInt(item.product_id)
                    );
                    shipmentData.items.forEach((p) => {
                      console.log(
                        "Checking item:",
                        item.product_id,
                        "vs product:",
                        p.id,
                        item,
                        p
                      );
                    });
                    /*products.push({
                                    productId: item.product_id,
                                    productName: product.product_name,
                                    qty: product.item_qty,
                                })*/
                    console.log(
                      "Here is the data",
                      item,
                      product,
                      "This is log",
                      logisticData
                    );
                    shipmentItems.push({
                      id: item.id,
                      productId: item.product_id,
                      productName: product?.product_name,
                      mainProductId: product?.item_name,
                      batchNo: item?.batch_no,
                      mfg: item?.mfg,
                      noBags: item?.no_of_bags ?? 0,
                      qty: product?.item_qty,
                      remarks: item?.remarks,
                      location: item?.office_location_id,
                    });
                  });
                const shipment = {
                  shipmentId: shipmentData.id,
                  shipmentName: shipmentData.shipment_name,
                  address: shipmentData.address,
                  addressType: shipmentData.address_type,
                  shipmentMethod: shipmentData.shipment_method,
                  godownId: shipmentData.godown_id,
                  godownName: shipmentData.godown_name,
                  items: shipmentItems,
                  products: products,
                };
                console.log("Shipment data", shipment);

                shipments.push(shipment);
              });
          } else {
            res?.shipment &&
              res?.shipment.map((shipmentData, index) => {
                const shipmentItems = [];
                const products = [];
                shipmentData.items.map((item) => {
                  console.log("By default data", item);
                  products.push({
                    productId: item.id,
                    mainProductId: item.item_name,

                    productName: item.product_name,
                    qty: item.item_qty,
                  });
                  shipmentItems.push({
                    productId: item.id,
                    productName: item.product_name,
                    mainProductId: item.item_name,
                    batchNo: "",
                    mfg: "",
                    noBags: 0,
                    qty: item.item_qty,
                    remarks: "",
                    location: "",
                  });
                });
                const shipment = {
                  shipmentId: shipmentData.id,
                  shipmentName: shipmentData.shipment_name,
                  address: shipmentData.address,
                  addressType: shipmentData.address_type,
                  shipmentMethod: shipmentData.shipment_method,
                  godownId: shipmentData.godown_id,
                  godownName: shipmentData.godown_name,
                  items: [],
                  products: products,
                };
                console.log("Here is the data going", shipment);
                shipments.push(shipment);
              });
          }

          setFormData({
            orderId,
            llDate: piData?.loading_date
              ? moment(piData?.loading_date).toDate()
              : new Date(),
            dcNo: piData?.deliverynoteno,
            vehicleNo: piData?.motor_vehicle_no,
            transporterName: piData?.transporter_name,
            partyName: props.rowData?.channel_partner_name,
            soNo: props.rowData?.order_id,
            lrNo: piData?.bill_of_landing_lr_rr_no,
            startTime: piData?.loading_start_time
              ? moment(piData?.loading_start_time).toDate()
              : "",
            endTime: piData?.loading_end_time
              ? moment(piData?.loading_end_time).toDate()
              : "",
          });
          setShipments(shipments);
        } else {
          const propdata = { mode: "list" };
          props.onChange(propdata);
        }
      })
      .catch((err) => {
        console.log(err);
        const propdata = { mode: "list" };
        props.onChange(propdata);
      });
  };

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleShipmentInputChange = (e, shippingIndex, itemIndex) => {
    const { name, value } = e.target;
    const newShipments = [...shipments];

    if (name === "productId") {
      const selectedProduct = newShipments[shippingIndex].products.find(
        ({ mainProductId }) => mainProductId === value
      );

      if (selectedProduct) {
        console.log("Selected prduct", selectedProduct);
        newShipments[shippingIndex].items[itemIndex] = {
          ...newShipments[shippingIndex].items[itemIndex],
          productId: selectedProduct.productId,
          productName: selectedProduct.productName,
          mainProductId: selectedProduct.mainProductId,
          noBags: "",
        };
      }
    } else if (name === "noBags") {
      const productId = newShipments[shippingIndex].items[itemIndex].productId;

      // Calculate the total bags across all instances of this product in the current shipment
      let totalBagsForProduct = 0;
      newShipments[shippingIndex].items.forEach((item, i) => {
        if (item.productId === productId) {
          totalBagsForProduct +=
            i === itemIndex
              ? parseInt(value || 0, 10)
              : parseInt(item.noBags || 0, 10);
        }
      });

      const selectedProduct = newShipments[shippingIndex].products.find(
        (product) => product.productId === productId
      );

      if (selectedProduct) {
        const totalQuantity = selectedProduct.qty;

        if (totalBagsForProduct > totalQuantity) {
          showMessage(
            `Number of bags cannot exceed the total quantity of ${totalQuantity} for ${selectedProduct.productName} in ${newShipments[shippingIndex].shipmentName}.`,
            "error"
          );
          return;
        }

        // Debugging information
        /* const debugItems = newShipments[shippingIndex].items
                    .filter(item => item.productId === newShipments[shippingIndex].items[itemIndex].productId)
                    .map((item, i) => `Row ${i + 1}:\nProduct Name: ${item.productName}, Total Qty: ${selectedProduct.qty}, Bags Total: ${totalBagsForProduct}, Enter Input: ${value}`);
                console.log(debugItems.join('\n'));*/
      }

      // Update the noBags value only if validation passes
      newShipments[shippingIndex].items[itemIndex][name] = value;
    } else {
      newShipments[shippingIndex].items[itemIndex][name] = value;
    }

    // Update state
    setShipments(newShipments);
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmit(true);
  };

  useEffect(() => {
    if (isSubmit) {
      // console.log("Form Data From Submit", formData)
      // console.log("Shipment From Submit",shipments)

      if (formData.startTime) {
        setValidated(false);
      }

      if (formData.endTime) {
        setValidated(false);
      }

      const products = [];
      shipments.map((shipment) => {
        const items = shipment?.items;
        console.log("here is the id", items);
        items.map((item) => {
          products.push({
            id: item.id,
            product_id: item.productId,
            main_product_id: item.mainProductId,
            shipment_id: shipment.shipmentId,
            office_location_id: item.location,
            batch_no: item.batchNo,
            mfg: item.mfg,
            no_of_bags: item.noBags,
            remarks: item.remarks,
          });
        });
      });
      console.log("Hrtr is the products", products);

      const requestData = {
        order_id: formData.orderId,
        loading_date: formData.llDate,
        loading_start_time: formData.startTime,
        loading_end_time: formData.endTime,
        bill_of_landing_lr_rr_no: formData.lrNo,
        products: products,
        product_delete: removedItemIds,
      };
      // console.log(removedItemIds); setIsSubmit(false);
      utils
        .callAPI("post", "/sales/add_loading_logistic", requestData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            const propdata = { mode: "list" };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const getLocationList = () => {
    utils
      .callAPI("get", `/sales/getLocationList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setOfficeLocation(res.result);
        } else {
          setOfficeLocation([]);
        }
      })
      .catch((err) => {
        setOfficeLocation([]);
      });
  };

  const handleAddProductAddClick = (i) => {
    const newShipments = [...shipments];
    newShipments[i].items.push({
      id: 0,
      productId: 0,
      productName: "",
      batchNo: "",
      mfg: "",
      noBags: "",
      mainProductId: "",
      remarks: "",
      location: "",
    });
    setShipments(newShipments);
  };

  const handleDeleteProductClick = (shipmentIndex, itemIndex) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const newShipments = [...shipments];
        const removedItem = newShipments[shipmentIndex].items[itemIndex];
        if (removedItem.id > 0) {
          setRemovedItemIds((prev) => [...prev, { id: removedItem.id }]);
          newShipments[shipmentIndex].items.splice(itemIndex, 1);
        } else {
          newShipments[shipmentIndex].items.splice(itemIndex, 1);
        }
        // newShipments[shipmentIndex].items.splice(itemIndex, 1);
        setShipments(newShipments);
      }
    });
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4>Logistic Loading</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Card className="border-0">
              <RB.CardBody className="p-0 border-0">
                <RB.Row>
                  <RB.Col md={3} className="no-validation-icon">
                    <div className="mb-3 mt-3">
                      <RB.FloatingLabel
                        label="Date"
                        className={`floating-label-fancy ${
                          formData.llDate ? "dateSelected" : "dateempty"
                        }`}
                      >
                        <DatePicker
                          selected={formData.llDate}
                          onChange={(date) =>
                            setFormData({ ...formData, llDate: date })
                          }
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={3} className="no-validation-icon">
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Delivery Challan No."
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Delivery Challan No."
                          name="dcNo"
                          readOnly={true}
                          value={formData.dcNo}
                          onChange={handleInputChange}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={3} className="no-validation-icon">
                    <div className="mb-3 mt-3">
                      <RB.FloatingLabel
                        label="Start Time"
                        className={`floating-label-fancy ${
                          formData.startTime ? "dateSelected" : "dateempty"
                        }`}
                      >
                        <DatePicker
                          selected={formData.startTime}
                          onChange={(date) =>
                            setFormData({ ...formData, startTime: date })
                          }
                          dateFormat="h:mm aa"
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          className="form-control"
                          showMonthDropdown
                          showYearDropdown
                          timeCaption="Start Time"
                          required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={3} className="no-validation-icon">
                    <div className="mb-3 mt-3">
                      <RB.FloatingLabel
                        label="End Time"
                        className={`floating-label-fancy ${
                          formData.endTime ? "dateSelected" : "dateempty"
                        }`}
                      >
                        <DatePicker
                          selected={formData.endTime}
                          onChange={(date) =>
                            setFormData({ ...formData, endTime: date })
                          }
                          dateFormat="h:mm aa"
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          className="form-control"
                          showMonthDropdown
                          showYearDropdown
                          timeCaption="End Time"
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                </RB.Row>

                <RB.Row>
                  <RB.Col md={4} className="no-validation-icon">
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Vehical No."
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Vehical No."
                          name="vehicleNo"
                          readOnly={true}
                          value={formData.vehicleNo}
                          onChange={handleInputChange}
                          maxLength={32}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={4} className="no-validation-icon">
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Transporter Name"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Transporter Name"
                          name="transporterName"
                          value={formData.transporterName}
                          readOnly={true}
                          onChange={handleInputChange}
                          maxLength={32}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={4} className="no-validation-icon">
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Party Name"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Party Name"
                          name="partyName"
                          value={formData.partyName}
                          readOnly={true}
                          onChange={handleInputChange}
                          maxLength={32}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                </RB.Row>

                <RB.Row>
                  <RB.Col md={6} className="no-validation-icon">
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="L.R. No."
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="L.R. No."
                          name="lrNo"
                          value={formData.lrNo}
                          onChange={handleInputChange}
                          maxLength={32}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={6} className="no-validation-icon">
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="S.O. No."
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="S.O. No."
                          name="soNo"
                          readOnly={true}
                          value={formData.soNo}
                          onChange={handleInputChange}
                          maxLength={32}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                </RB.Row>
              </RB.CardBody>
            </RB.Card>
            {shipments &&
              shipments.map((shipment, index) => (
                <RB.Card key={index}>
                  <RB.CardHeader>
                    <div
                      className={
                        "d-flex align-items-center justify-content-between w-100"
                      }
                    >
                      <h4>{shipment.shipmentName}</h4>
                      <Button
                        typeof={"button"}
                        className={"btn btn-primary btn-sm"}
                        onClick={() => handleAddProductAddClick(index)}
                      >
                        Add Product
                      </Button>
                    </div>
                  </RB.CardHeader>
                  <RB.CardHeader>
                    <RB.Row className="w-100">
                      <RB.Col md={1}>
                        <span className="text-uppercase fw-bold small text-body-secondary ">
                          Type
                        </span>
                        <p className="fw-medium text-sm fw-semibold mb-0">
                          {shipment?.addressType}
                        </p>
                      </RB.Col>
                      {shipment.godownId !== "0" && (
                        <RB.Col md={3}>
                          <span className="text-uppercase fw-bold small text-body-secondary">
                            Godown
                          </span>
                          <p className="fw-medium text-sm fw-semibold mb-0">
                            {shipment.godownName}
                          </p>
                        </RB.Col>
                      )}
                      <RB.Col md={3}>
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Shipping Method
                        </span>
                        <p className="fw-medium text-sm fw-semibold mb-0">
                          {shipment?.shipmentMethod}
                        </p>
                      </RB.Col>
                      <RB.Col md={true}>
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Shipping Address
                        </span>
                        <p className="fw-medium text-sm fw-semibold mb-0">
                          {shipment?.address}
                        </p>
                      </RB.Col>
                    </RB.Row>
                  </RB.CardHeader>
                  <div className={"table-responsive"}>
                    <Table
                      className={"table table-bordered logistic-loading mb-0"}
                    >
                      <thead>
                        <tr>
                          <th className={"text-center"} style={{ width: "3%" }}>
                            Sr.No.
                          </th>
                          <th style={{ width: "20%" }}>Products</th>
                          <th className={"text-center"}>Batch No.</th>
                          <th className={"text-center"}>Mfg.</th>
                          <th className={"text-center"}>
                            No. of Bags / Containers / Barrels
                          </th>
                          <th className={"text-center"}>Remarks</th>
                          <th
                            className={"text-center"}
                            style={{ width: "15%" }}
                          >
                            Location
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {shipment.items &&
                          shipment.items.map((item, i) => (
                            <tr key={i}>
                              <td
                                className={"text-center"}
                                data-label="Sr. No.:"
                              >
                                {i + 1}
                              </td>

                              <td data-label="Products:">
                                <RB.Form.Select
                                  size="sm"
                                  name="productId"
                                  value={item.mainProductId}
                                  onChange={(e) =>
                                    handleShipmentInputChange(e, index, i)
                                  }
                                >
                                  {console.log("HEre is", item)}
                                  <option value={"0"}>Select Product</option>
                                  {shipment.products.map(
                                    (
                                      { productId, productName, mainProductId },
                                      j
                                    ) => (
                                      <option key={j} value={mainProductId}>
                                        {productName}
                                      </option>
                                    )
                                  )}
                                </RB.Form.Select>
                              </td>
                              <td data-label="Batch No.:">
                                <RB.Form.Control
                                  size={"sm"}
                                  type="text"
                                  placeholder="Batch No."
                                  name="batchNo"
                                  value={shipments[index].items[i].batchNo}
                                  onChange={(e) =>
                                    handleShipmentInputChange(e, index, i)
                                  }
                                  maxLength={32}
                                />
                              </td>
                              <td data-label="Mfg.:">
                                <RB.Form.Control
                                  size={"sm"}
                                  type="text"
                                  placeholder="Mfg."
                                  name="mfg"
                                  value={shipments[index].items[i].mfg}
                                  onChange={(e) =>
                                    handleShipmentInputChange(e, index, i)
                                  }
                                  maxLength={32}
                                />
                              </td>
                              <td data-label="No. of Bags / Containers / Barrels:">
                                <RB.Form.Control
                                  size={"sm"}
                                  type="text"
                                  placeholder="No. of Bags / Containers / Barrels"
                                  name="noBags"
                                  value={shipments[index].items[i].noBags}
                                  onChange={(e) =>
                                    handleShipmentInputChange(e, index, i)
                                  }
                                  maxLength={32}
                                />
                              </td>
                              <td data-label="Remarks:">
                                <RB.Form.Control
                                  size={"sm"}
                                  type="text"
                                  placeholder="Remarks"
                                  name="remarks"
                                  value={shipments[index].items[i].remarks}
                                  onChange={(e) =>
                                    handleShipmentInputChange(e, index, i)
                                  }
                                  maxLength={32}
                                />
                              </td>
                              <td data-label="Location:">
                                <RB.Form.Select
                                  size={"sm"}
                                  name="location"
                                  value={shipments[index].items[i].location}
                                  onChange={(e) =>
                                    handleShipmentInputChange(e, index, i)
                                  }
                                >
                                  <option value={""}>Select</option>
                                  {officeLocation.map((location, i) => (
                                    <option key={i} value={location.id}>
                                      {location.name}
                                    </option>
                                  ))}
                                </RB.Form.Select>
                              </td>
                              <td>
                                <Button
                                  type={"button"}
                                  className={"btn btn-danger btn-sm"}
                                  onClick={() =>
                                    handleDeleteProductClick(index, i)
                                  }
                                >
                                  {" "}
                                  <DeleteIcon />
                                </Button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                  {/*<RB.CardBody className="ll-custom-table-view">


                                    <RB.Row className="table-row table-header-row">
                                        <RB.Col md={1} className="table-col table-col-header">Sr. No.</RB.Col>
                                        <RB.Col md={true} className="table-col table-col-header">Products</RB.Col>
                                        <RB.Col md={2} className="table-col table-col-header">Batch No.</RB.Col>
                                        <RB.Col md={2} className="table-col table-col-header">Mfg.</RB.Col>
                                        <RB.Col md={2} className="table-col table-col-header">No. of Bags / Containers /
                                            Barrels</RB.Col>
                                        <RB.Col md={2} className="table-col table-col-header">Remarks</RB.Col>
                                        <RB.Col md={true} className="table-col table-col-header">Location</RB.Col>
                                        <RB.Col md={"auto"}
                                                className="table-col table-col-header"><DeleteIcon/></RB.Col>
                                    </RB.Row>

                                    {shipment.items && shipment.items.map((item, i) => (
                                        <RB.Row key={i} className="table-row">
                                            <RB.Col md={1} className="table-col justify-content-center"
                                                    data-lable="Sr. No.:">{i + 1}</RB.Col>
                                            <RB.Col md={true} className="table-col"
                                                    data-lable="Products:">{item.productName}</RB.Col>
                                            <RB.Col md={2} className="table-col" data-lable="Batch No.:">
                                                <RB.Form.Control
                                                    type="text"
                                                    placeholder="Batch No."
                                                    name="batchNo"
                                                    value={shipments[index].items[i].batchNo}
                                                    onChange={(e) =>
                                                        handleShipmentInputChange(e, index, i)
                                                    }
                                                    maxLength={32}
                                                />
                                            </RB.Col>
                                            <RB.Col md={2} className="table-col" data-lable="Mfg.:">
                                                <RB.Form.Control
                                                    type="text"
                                                    placeholder="Mfg."
                                                    name="mfg"
                                                    value={shipments[index].items[i].mfg}
                                                    onChange={(e) =>
                                                        handleShipmentInputChange(e, index, i)
                                                    }
                                                    maxLength={32}
                                                />
                                            </RB.Col>
                                            <RB.Col md={2} className="table-col"
                                                    data-lable="No. of Bags / Containers / Barrels:">
                                                <RB.Form.Control
                                                    type="text"
                                                    placeholder="No. of Bags / Containers / Barrels"
                                                    name="noBags"
                                                    value={shipments[index].items[i].noBags}
                                                    onChange={(e) =>
                                                        handleShipmentInputChange(e, index, i)
                                                    }
                                                    maxLength={32}
                                                />
                                            </RB.Col>
                                            <RB.Col md={2} className="table-col" data-lable="Remarks:">
                                                <RB.Form.Control
                                                    type="text"
                                                    placeholder="Remarks"
                                                    name="remarks"
                                                    value={shipments[index].items[i].remarks}
                                                    onChange={(e) =>
                                                        handleShipmentInputChange(e, index, i)
                                                    }
                                                    maxLength={32}
                                                />
                                            </RB.Col>
                                            <RB.Col md={true} className="table-col" data-lable="Location:">
                                                <RB.Form.Control
                                                    type="text"
                                                    placeholder="Remarks"
                                                    name="remarks"
                                                    value={shipments[index].items[i].remarks}
                                                    onChange={(e) =>
                                                        handleShipmentInputChange(e, index, i)
                                                    }
                                                    maxLength={32}
                                                />
                                            </RB.Col>
                                            <RB.Col md={"auto"} className="table-col" data-lable="Remove:">
                                                <a className={"text-danger"}> <DeleteIcon/></a>
                                            </RB.Col>
                                        </RB.Row>
                                    ))}
                                </RB.CardBody>*/}
                </RB.Card>
              ))}

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default LogisticLoadingForm;
